import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import PackagesPage from '@/routes/packages/PackagesPage'
import { PackagesSaleGridRoute } from '@/routes/packages/sale/PackagesSaleGrid.route'
import { PackagesUsageGridRoute } from '@/routes/packages/usage/PackagesUsageGrid.route'
import { RoleRoute } from '@/types'
import { redirect } from 'react-router-dom'
import { faBoxesPacking } from '@fortawesome/free-solid-svg-icons'

export const packagesSubRoutes: RoleRoute[] = [
  {
    index: true,
    loader: () => redirect('sale'),
    visible: false,
    allowedRoles: [Roles.Guest],
  },
  PackagesSaleGridRoute,
  PackagesUsageGridRoute,
]

export const PackagesPageRoute: RoleRoute = {
  path: 'packages',
  element: <PackagesPage />,
  errorElement: <RouterErrorHandler />,
  children: packagesSubRoutes,
  text: 'Pacchetti',
  faIcon: faBoxesPacking,
  mainMenuRoute: true,
  handle: {
    crumb: () => ({
      label: 'Pacchetti',
      icon: faBoxesPacking,
    }),
  },
  allowedRoles: [Roles.Guest],
}
